import { useStore } from "../store/store";
import { useT } from "../i18n/useT";
import { DISCLOSURES } from "@mensajeando/compliance";

export function Settings() {
  const t = useT();
  const resetSeed = useStore((s) => s.resetSeed);
  const orgs = useStore((s) => s.organizations);

  return (
    <div>
      <header className="mb-6">
        <h1 className="text-2xl font-semibold">{t.nav.settings}</h1>
      </header>

      <section className="card card-pad mb-4">
        <h2 className="font-semibold mb-2">Organizations</h2>
        <ul className="text-sm">
          {orgs.map((o) => (
            <li key={o.id} className="flex justify-between py-1 border-b border-slate-100 last:border-0">
              <span>{o.name}</span>
              <span className="text-slate-500">{o.supportEmail}</span>
            </li>
          ))}
        </ul>
      </section>

      <section className="card card-pad mb-4">
        <h2 className="font-semibold mb-2">{t.compliance.disclosureLibrary}</h2>
        <p className="text-xs text-slate-500 mb-3">
          Versioned per campaign type, channel, and language. Every consent record stores its disclosure version for audit.
        </p>
        <div className="grid grid-cols-2 gap-3">
          {DISCLOSURES.map((d, i) => (
            <div key={i} className="rounded border border-slate-200 p-3 text-xs">
              <div className="flex gap-1 mb-1">
                <span className="badge-muted">{d.campaignType}</span>
                <span className="badge-muted">{d.channel}</span>
                <span className="badge-muted">{d.language}</span>
              </div>
              <div className="font-mono text-[10px] text-slate-500 mb-1">{d.version}</div>
              <div className="text-slate-700">{d.cta}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="card card-pad">
        <h2 className="font-semibold mb-2">Demo controls</h2>
        <p className="text-xs text-slate-500 mb-3">This is a client-side demo backed by localStorage. Use this to reset the seeded contacts, consent records, and campaigns.</p>
        <button className="btn-danger" onClick={() => { if (confirm("Reset all demo data?")) resetSeed(); }}>
          Reset demo data
        </button>
      </section>
    </div>
  );
}
